import { useFormik } from "formik";

import React, { Fragment, useEffect, useState } from "react";
import {
  createAffiliateAgent,
  getAllAffiliateAgentById,
  getAllAffiliateAgents,
  updateAffiliateAgent,
} from "../../Redux/Actions/affiliateAgent";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import DataTable from "../../utils/dataTable";
import CustomModal from "../../utils/customModal";
import affiliateAgentSchema from "../../SchemaValidation/affiliateAgentSchema";
import { toastMessage } from "../../utils/toast";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";

const initialCreateFormValues = {
  name: "",
  mobileNumber: "",
  email: "",
  password: "",
  emiratesId: "",
  isActive: false,
  emiratesIdDocument: null,
};

const formType = [
  { name: "name", type: "text", label: "Name" },
  { name: "email", type: "email", label: "Email" },
  { name: "password", type: "password", label: "Password" },
  { name: "mobileNumber", type: "number", label: "Mobile Number" },
  { name: "emiratesId", type: "number", label: "Emirates Id" },
  { name: "isActive", type: "checkbox", label: "Status" },
  { name: "emiratesIdDocument", type: "file", label: "Emirates Id Document" },
];

function AffiliateAgent({ history }) {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
  const [agents, setAgents] = useState({
    data: [],
    totalCount: 0,
    isShow: false,
    isLoading: false,
  });
  const [agentDetails, setAgentDetails] = useState({
    ...initialCreateFormValues,
  });
  const [filterState, setFilterState] = useState({
    emiratesId: "",
    mobileNumber: "",
    email: "",
    isFilter:false
  });
  const [loading, setLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(true);

  const columns = [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Mobile Number",
      accessor: "mobileNumber",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Emirates Id",
      accessor: "emiratesId",
    },
    {
      Header: "Status",
      accessor: "isActive",
      Cell: ({ cell }) => (
        <div>
          {cell.row.original.isActive ? <p>Active</p> : <p>InActive</p>
          }
        </div>)
    },
    {
      Header: "Action",
      accessor: "ContactPersonEmail",
      Cell: ({ cell }) => (
        <div>
          {cell.row.original.id && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "150px",
              }}
            >
              <button
                className="json-button btn btn-sm btn-primary"
                onClick={() => {
                  setIsCreate(false);
                  setAgents((preState) => ({
                    ...preState,
                    id: cell.row.original.id,
                    isShow: true,
                  }));
                }}
              >
                {"Edit"}
              </button>
              <p
                onClick={() =>
                  history.push(`/affiliat-agent-info/${cell.row.original.id}`)
                }
                className="btn btn-info font-weight-bolder font-size-sm me-2"
              >
                {t("jobsManagement.manageJobs.more")}
              </p>
            </div>
          )}
        </div>
      ),
    },
  ];

  useEffect(()=>{
    if(filterState.isFilter)
      getAllAffiliateAgentsApi(0);
  },[filterState])
  console.log({filterState});
  useEffect(() => {
    getAllAffiliateAgentsApi(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (agents.id) {
      getAgentDetailByIdApi(agents.id);
    }
  }, [agents.id]);

  const getAgentDetailByIdApi = async (id) => {
    setLoading(true);
    try {
      const response = await apiWrapWithErrorWithData(
        getAllAffiliateAgentById(id)
      );
      setLoading(false);
      const tempAgent = response?.data;
      setAgentDetails((preState) => ({
        ...preState,
        name: tempAgent.name,
        email: tempAgent.email,
        mobileNumber: tempAgent.mobileNumber,
        emiratesId: tempAgent.emiratesId,
        isActive: tempAgent.isActive,
        password: "Password",
      }));
    } catch (error) {
      console.log("getAgentDetailByIdApi", error);
    }
  };

  const getAllAffiliateAgentsApi = async (page) => {
    try {
      const respone = await apiWrapWithErrorWithData(
        getAllAffiliateAgents(page,filterState)
      );
      setAgents((preState) => ({
        ...preState,
        data: respone.data?.affiliateAgents || [],
        totalCount: respone.data?.totalCount || 0,
      }));
      setFilterState((preState)=>{
        return {
          ...preState,
          isFilter:false
        }
      });
    } catch (error) {
      console.log("getAllAffiliateAgentsApi", error);
    }
  };
  const options = [
    { value: false, label: 'InActive' },
    { value: true, label: 'Active' }
  ];

  const formik = useFormik({
    initialValues: agentDetails,
    enableReinitialize: true,
    validationSchema: affiliateAgentSchema,
    onSubmit: async (values) => {
      setAgents((preState) => ({ ...preState, isLoading: true }));
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("mobileNumber", values.mobileNumber);
      formData.append("emiratesId", values.emiratesId);
      formData.append("emiratesIdDocument", values.emiratesIdDocument);
      formData.append("isActive", values.isActive);
      if (!agents.id) {
        formData.append("password", values.password);
      }

      try {
        var agentCreateResponse = await apiWrapWithErrorWithData(
          agents.id
            ? updateAffiliateAgent(agents.id, formData)
            : createAffiliateAgent(formData)
        );

        if (agentCreateResponse.status == 400) {
          var errorList = "";
          if (agentCreateResponse.data?.data?.validations) {
            agentCreateResponse.data.data.validations.map((error, i) => {
              errorList = errorList + `<p>` + error + `</p>`;
            });
          } else {
            errorList = "Somthing want wrong";
          }
          if (errorList != "") {
            toastMessage(
              "error",
              <div dangerouslySetInnerHTML={{ __html: errorList }} />
            );
          }
        } else {
          toastMessage('success', agentCreateResponse.message);
          setCurrentPage(0);
          getAllAffiliateAgentsApi(0);
          handleClose();
        }
      } catch (error) {
        toastMessage("error", "somethink went wrong");
        console.log(error);
      }
      setAgents((preState) => ({
        ...preState,
        isLoading: false,
      }));
    },
  });

  const body = (
    <form autoComplete="off" noValidate>
      {formType.map(({ name, type, label }) => {
        const shouldDisplayField = !agents.id || !["password"].includes(name);

        if (!shouldDisplayField) return null;

        return (
          <>
            <label
              className="form-label col-md-4 col-sm-2"
              style={{ marginTop: "5px" }}
            >
              {label}
            </label>
            {name === "emiratesIdDocument" ? (
              <input
                className="p-1 form-control col-md-4 col-sm-2"
                name={name}
                type="file"
                onChange={(event) => {
                  formik.setFieldValue(name, event.currentTarget.files[0]);
                }}
              />
            ) : (
              <div>{type === 'checkbox' ?
                <select
                  name={name}
                  onChange={formik.handleChange}
                  value={formik.values[name]}
                  className="form-select"
                >
                  {options.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select> :
                <input
                  className="p-1 form-control col-md-4 col-sm-2"
                  name={name}
                  type={type}
                  autoComplete={"new-" + type}
                  onChange={formik.handleChange}
                  value={formik.values[name]}
                  placeholder={`Please enter ${label.toLowerCase()}`}
                />
              }</div>
            )}
            {formik.touched[name] && formik.errors[name] ? (
              <div style={{ color: "red" }}>{formik.errors[name]}</div>
            ) : null}
          </>
        );
      })}
    </form>
  );

  const handleClose = () => {
    setIsCreate(true);
    formik.resetForm();
    setAgentDetails({ ...initialCreateFormValues });
    setAgents((preState) => ({ ...preState, id: 0, isShow: false }));
  };

  const handleFilterState = (field, value) => {
    setFilterState((preState) => ({
      ...preState,
      [field]: value,
    }));
  };

  const handleFilter = () => {
    setCurrentPage(0);
    handleFilterState("isFilter",true)
  };

  const clearFilter = () => {
    setCurrentPage(0);
    setFilterState((preState)=>{
      return {
        ...preState,
        emiratesId: "",
      mobileNumber: "",
      email: "",
      isFilter:true
      }
    });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="page-title my-2">{t("affiliateAgent.title")}</h4>
        </div>
        <div className="row">
          <div className="col-lg-12 col-xxl-12">
            <div className="card card-custom card-stretch gutter-b">
              {loading ? (
                <Loader
                  type="ThreeDots"
                  color="#2d207d"
                  height={40}
                  width={40}
                  style={{ textAlign: "center", marginBottom: "50px" }}
                />
              ) : (
                <div className="card-body p-3">
                  <div className="tab-content">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center mb-3">
                        <div className="me-3" style={{ width: "45%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("affiliateAgent.filter.lable.email")}
                          </label>
                          <input
                            placeholder={t(
                              "affiliateAgent.filter.placeholder.email"
                            )}
                            type="email"
                            className="form-control me-3"
                            name=""
                            value={filterState.email}
                            onChange={(e) =>
                              handleFilterState("email", e.target.value)
                            }
                          />
                        </div>
                        <div className="me-3" style={{ width: "45%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("affiliateAgent.filter.lable.mobileNumber")}
                          </label>
                          <input
                            placeholder={t(
                              "affiliateAgent.filter.placeholder.mobileNumber"
                            )}
                            type="number"
                            className="form-control me-3"
                            name="mobileNumber"
                            value={filterState.mobileNumber}
                            onChange={(e) =>
                              handleFilterState("mobileNumber", e.target.value)
                            }
                          />
                        </div>
                        <div className="me-3" style={{ width: "45%" }}>
                          <label className="mb-1 ms-1 me-3">
                            {t("affiliateAgent.filter.lable.emiratesId")}
                          </label>
                          <input
                            placeholder={t(
                              "affiliateAgent.filter.placeholder.emiratesId"
                            )}
                            type="number"
                            className="form-control me-3"
                            name="emiratesId"
                            value={filterState.emiratesId}
                            onChange={(e) =>
                              handleFilterState("emiratesId", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-primary m-3"
                          onClick={() =>
                            setAgents((preState) => ({
                              ...preState,
                              id: 0,
                              isShow: true,
                            }))
                          }
                        >
                          Create Agent
                        </button>
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <button
                        onClick={handleFilter}
                        type="button"
                        className="d-flex px-5 align-items-center btn btn-primary font-weight-bold"
                      >
                        {t("jobsManagement.filters.filter")}
                      </button>
                      <button
                        onClick={clearFilter}
                        type="button"
                        className="px-5 d-flex align-items-center btn btn-primary font-weight-bold mx-2"
                      >
                        {t("jobsManagement.filters.clearFilters")}
                      </button>
                    </div>
                    <div className="table-responsive">
                      <DataTable
                        columns={columns}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        data={agents.data}
                        totalCount={agents.totalCount}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        body={body}
        handleClose={handleClose}
        show={agents.isShow}
        title={`${isCreate ? "Create" : "Update"} Agent`}
        name={"Save changes"}
        isLoading={agents.isLoading}
        handleSubmit={formik.handleSubmit}
      />
    </>
  );
}

export default AffiliateAgent;
